/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {AbstractField} from '../abstract-field';

@Component({
  selector: 'gp-form-field-text-area',
  template: `
    <textarea class="textarea-control"
              [formControl]="control"
              [attr.test-id]="descriptor.zoneID"
              [(ngModel)]="value.value"
              (focus)="onFocus()"
              (blur)="onBlur()"
              [style.resize]="readOnly ? 'none' : null"
              [attr.readOnly]="readOnly ? 'true' : null"
              [rows]="descriptor.nbRows">
    </textarea>
  `,
  styleUrls: ['./textarea-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextAreaFieldComponent extends AbstractField implements OnInit {

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.bindDependencyTriggered();
  }

  protected afterDependencyHandled() {
    this.cd.markForCheck();
  }
}
